import { configureStore } from "@reduxjs/toolkit";
import blogReducer from "../feature/blog.slice";

export const store = configureStore({
    reducer: {
        blog: blogReducer
    },
});